import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { filterSet } from '../../../actions/index';

class FilterItemNumber extends Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    filterSet: PropTypes.func.isRequired,
    onChange: PropTypes.func,
  };
  handleChange = (e, p) => {
    this.props.filterSet({ name: p.name, value: p.value });
    if (this.props.onChange) {
      this.props.onChange(e, {
        name: p.name,
        value: p.value,
      });
    }
  };

  render() {
    return (
      <Form.Input
        name={this.props.name}
        label={this.props.label}
        type="text"
        value={this.props.value}
        onChange={this.handleChange}
      />
    );
  }
}

export default connect(
  (state, props) => ({
    value: state.filter[props.name] ? state.filter[props.name].value : '',
  }),
  { filterSet },
)(FilterItemNumber);
